import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import ManagerDashboard from './pages/ManagerDashboard';
import ResidentDashboard from './pages/ResidentDashboard';
import PublicPayment from './pages/PublicPayment'; 
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import PaymentSettings from './pages/PaymentSettings';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<SuperAdminDashboard />} />
        <Route path="/manager" element={<ManagerDashboard />} />
        <Route path="/resident" element={<ResidentDashboard />} />
        <Route path="/pay/:token" element={<PublicPayment />} /> 
        <Route path="/payment-settings" element={<PaymentSettings />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;